import { Helmet } from 'react-helmet-async';
import { useState, useEffect } from 'react';
// @mui
import { Stack, Typography, Grid, Button, Box } from '@mui/material';
import TextField from '@mui/material/TextField';
import CardMedia from '@mui/material/CardMedia';
import PhoneInput from 'react-phone-input-2'

import CircularProgress from '@mui/material/CircularProgress';
import { getFirestore, collection, addDoc, serverTimestamp, setDoc, doc, Timestamp, getDocs, query, where   } from "firebase/firestore";
import { getDatabase, ref as dbref, runTransaction, set, child, get, update, remove } from "firebase/database";
import { initializeApp } from "firebase/app";
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import moment from "moment";

import 'react-phone-input-2/lib/material.css'

const firebaseConfig = {
  apiKey: "AIzaSyDLVrlBPuai36n-i4F5HQVTjSMkVeGVBak",
  authDomain: "onetweb-e3d8e.firebaseapp.com",
  databaseURL: "https://onetweb-e3d8e-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "onetweb-e3d8e",
  storageBucket: "onetweb-e3d8e.firebasestorage.app",
  messagingSenderId: "60910494595",
  appId: "1:60910494595:web:2dc6bf320d67371af04cb6",
  measurementId: "G-0ZTHXZBNP9"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const db = getFirestore(app);
const rtdb = getDatabase(app);



// ----------------------------------------------------------------------

export default function HomePage() {

  const [mobileNum, setMobileNum] = useState('');
      
  const [firstNameError, setFirstNameError] = useState(false);
  const [lastNameError, setLastNameError] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [mobileNumError, setMobileNumError] = useState(false);
  const [messageError, setMessageError] = useState(false);

  const [loading, setLoading] = useState(false);
  const [thankyou, setThankyou] = useState(false);

  const [title, setTitle] = useState('');
  const [subtitle, setSubTitle] = useState('');
  const [bgvideo1, setbgvideo1] = useState(null);

  const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up('md'));

  
    useEffect(() => {
  
        get(child(dbref(rtdb), `contactus`)).then((snapshot) => {
          if (snapshot.exists()) {
  
            setTitle(snapshot.val().title)
            setSubTitle(snapshot.val().subtitle)
            setbgvideo1(snapshot.val().bg_fullPath)
            setLoading(false);
  
          } else {
  
            setTitle('')
            setSubTitle('')
            setbgvideo1(null)
            setLoading(false);
            console.log("No data available");
          }
        }).catch((error) => {
          console.error(error);
        }); 
  
     
    }, [])

  const handleSubmit = async (event) => {
      event.preventDefault();
  
      let emailPass = false;
      let firstNamePass = false;
      let lastNamePass = false;
      let mobileNumPass = false;
      let messagePass = false;
  
      const data = new FormData(event.currentTarget);
  
      const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
      if(data.get('email').length > 0 && emailRegex.test(data.get('email'))){
        setEmailError(false)
        emailPass = true;
      }
      else
      {
        setEmailError(true)
      }

      if(mobileNum.length > 7){
        setMobileNumError(false)
        mobileNumPass = true;
      }
      else
      {
        setMobileNumError(true)
      }

  
      if(data.get('firstName').length > 1){
        setFirstNameError(false)
        firstNamePass = true;
      }
      else
      {
        setFirstNameError(true)
      }
  
      if(data.get('lastName').length > 1){
        setLastNameError(false)
        lastNamePass = true;
      }
      else
      {
        setLastNameError(true)
      }

      if(data.get('message').length > 1){
        setMessageError(false)
        messagePass = true;
      }
      else
      {
        setMessageError(true)
      }
      
      if(emailPass === true && 
        firstNamePass === true && 
        lastNamePass === true &&
        mobileNumPass === true &&
        messagePass === true )
      {
  
        const UID = `ID${Timestamp.fromDate(new Date()).toMillis()}`;
        update(dbref(rtdb, `contact_registration/${UID}` ), {
              id: UID,
              first_name: data.get('firstName') || null,
              last_name: data.get('lastName') || null,
              email: data.get('email') || null,
              company: data.get('company') || null,
              message: data.get('message') || null,
              mobile: mobileNum || null,
              created: Timestamp.fromDate(new Date()).toMillis(),
            })
            .then(() => {

              const emailID = `Email-${Timestamp.fromDate(new Date()).toMillis()}`;
                      try
                      {
                        setDoc(doc(db, "mail", emailID), {
                          to: ["info@onet.sg"],
                          message: {
                            subject: 'OneT - Contact Us',
                            html: `<!DOCTYPE html>
                            <html>
                            <head>
                            
                              <meta charset="utf-8">
                              <meta http-equiv="x-ua-compatible" content="ie=edge">
                              <title>OneT - Contact Us</title>
                              <meta name="viewport" content="width=device-width, initial-scale=1">
                              <style type="text/css">
                              /**
                               * Google webfonts. Recommended to include the .woff version for cross-client compatibility.
                               */
                              @media screen {
                                @font-face {
                                  font-family: 'Source Sans Pro';
                                  font-style: normal;
                                  font-weight: 400;
                                  src: local('Source Sans Pro Regular'), local('SourceSansPro-Regular'), url(https://fonts.gstatic.com/s/sourcesanspro/v10/ODelI1aHBYDBqgeIAH2zlBM0YzuT7MdOe03otPbuUS0.woff) format('woff');
                                }
                                @font-face {
                                  font-family: 'Source Sans Pro';
                                  font-style: normal;
                                  font-weight: 700;
                                  src: local('Source Sans Pro Bold'), local('SourceSansPro-Bold'), url(https://fonts.gstatic.com/s/sourcesanspro/v10/toadOcfmlt9b38dHJxOBGFkQc6VGVFSmCnC_l7QZG60.woff) format('woff');
                                }
                              }
                              /**
                               * Avoid browser level font resizing.
                               * 1. Windows Mobile
                               * 2. iOS / OSX
                               */
                              body,
                              table,
                              td,
                              a {
                                -ms-text-size-adjust: 100%; /* 1 */
                                -webkit-text-size-adjust: 100%; /* 2 */
                              }
                              /**
                               * Remove extra space added to tables and cells in Outlook.
                               */
                              table,
                              td {
                                mso-table-rspace: 0pt;
                                mso-table-lspace: 0pt;
                              }
                              /**
                               * Better fluid images in Internet Explorer.
                               */
                              img {
                                -ms-interpolation-mode: bicubic;
                              }
                              /**
                               * Remove blue links for iOS devices.
                               */
                              a[x-apple-data-detectors] {
                                font-family: inherit !important;
                                font-size: inherit !important;
                                font-weight: inherit !important;
                                line-height: inherit !important;
                                color: inherit !important;
                                text-decoration: none !important;
                              }
                              /**
                               * Fix centering issues in Android 4.4.
                               */
                              div[style*="margin: 16px 0;"] {
                                margin: 0 !important;
                              }
                              body {
                                width: 100% !important;
                                height: 100% !important;
                                padding: 0 !important;
                                margin: 0 !important;
                              }
                              /**
                               * Collapse table borders to avoid space between cells.
                               */
                              table {
                                border-collapse: collapse !important;
                              }
                              a {
                                color: #1a82e2;
                              }
                              img {
                                height: auto;
                                line-height: 100%;
                                text-decoration: none;
                                border: 0;
                                outline: none;
                              }
                              </style>
                            
                            </head>
                            <body style="background-color: #e9ecef;">
                            
                              <!-- start preheader -->
                              <div class="preheader" style="display: none; max-width: 0; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: #fff; opacity: 0;">
                              Thank you for using the OneT insurance. We are processing your application.
                              </div>
                              <!-- end preheader -->
                            
                              <!-- start body -->
                              <table border="0" cellpadding="0" cellspacing="0" width="100%">
                          
                            
                                <!-- start copy block -->
                                <tr>
                                  <td align="center" bgcolor="#e9ecef">
                                    <!--[if (gte mso 9)|(IE)]>
                                    <table align="center" border="0" cellpadding="0" cellspacing="0" width="600">
                                    <tr>
                                    <td align="center" valign="top" width="600">
                                    <![endif]-->
                                    <table border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width: 600px;">
                            
                                      <!-- start copy -->
                                      <tr>
                                        <td align="left" bgcolor="#ffffff" style="padding: 24px; font-family: 'Source Sans Pro', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;">
                                          <p style="margin: 0;">First Name: ${data.get('firstName') || ""}</p>
                                          <p style="margin: 0;">Last Name: ${data.get('lastName') || ""}</p>
                                          <p style="margin: 0;">Email: ${data.get('email') || ""}</p>
                                          <p style="margin: 0;">Company: ${data.get('company') || ""}</p>
                                          <p style="margin: 0;">Message: ${data.get('message') || ""}</p>
                                          <p style="margin: 0;">Phone Number: ${mobileNum || ""}</p>

                                          <p></p>
                                          <p style="margin: 0;">Please do not reply to this email.</p>
                                        </td>
                                      </tr>
                                      <!-- end copy -->
                            
                                      <!-- start copy -->
                                      <tr>
                                        <td align="left" bgcolor="#ffffff" style="padding: 24px; font-family: 'Source Sans Pro', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px; border-bottom: 3px solid #d4dadf">
                                          <p style="margin: 0;">Cheers,<br> OneT </p>
                                        </td>
                                      </tr>
                                      <!-- end copy -->

                                      <!-- start copy -->
                                      <tr>
                                        <td align="left" bgcolor="#ffffff" style="padding: 24px; font-family: 'Source Sans Pro', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px; border-bottom: 3px solid #d4dadf">
                                          <p style="margin: 0;">Date: ${moment().format("DD-MM-YYYY HH:mm")}</p>
                                        </td>
                                      </tr>
                                      <!-- end copy -->
                            
                                    </table>
                                    <!--[if (gte mso 9)|(IE)]>
                                    </td>
                                    </tr>
                                    </table>
                                    <![endif]-->
                                  </td>
                                </tr>
                                <!-- end copy block -->
                            
                              </table>
                              <!-- end body -->
                            
                            </body>
                            </html>`,
                          }
                        }).then(()=>{

                          
        
                        })

                        setLoading(false);
                        setThankyou(true);
                    }
                    catch(e)
                    {
                      // console.log(e)
                    }

              

            }) 
      }

  
  };

  const handleChangeMobileNum = (event) => {
    setMobileNum(event.trim())
  };
  
  if(loading){
    return (
      <Grid style={{ width: "100%", display: "flex", alignItems: "center",  flexDirection: "column"  }}>
        <Grid style={{ width: "100%", marginTop: 60, maxWidth: 1200, display: "flex", padding: 25, height: "80vh",
        flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
          <Box sx={{ display: 'flex' }}>
            <CircularProgress color="inherit" />
          </Box>
        </Grid>
      </Grid>
    );
  }

  if(thankyou){
      return(
        <Grid style={{ width: "100%", display: "flex", alignItems: "center",  flexDirection: "column"  }}>
  
        <Grid style={{ zIndex:-1, position: "fixed", top: 0,backgroundColor: '#1b0049', 
            height: "110vh",
          display: "flex", justifyContent: "flex-end", flexDirection: "column"  }}>
              <video height={"100%"} className='videoTag' playsInline autoPlay loop muted>
                  <source src={"/assets/videobg.mp4"} type='video/mp4' />
              </video>
            </Grid>
  
            <Grid style={{  maxWidth: 1200, zIndex:1, marginTop: 50, width: "100%", display: "flex", padding: 25,  paddingTop: 60, paddingBottom: 80,
              flexDirection: "column", justifyContent: "center", backgroundColor: "Transparent" }}>
              <Typography style={{ fontWeight: "bold", fontSize: 40, color: 'white', textTransform: "uppercase" }}>
              Thank You For Your Registration.
              </Typography>
          </Grid>
  
          <Grid style={{ zIndex:1, backgroundColor: 'White', width: "100%", display: "flex",
         justifyContent: "center", alignItems: "center",  padding: 30,
            flexDirection: "column" }}>
            <Typography align='center' style={{ fontSize: 12, marginTop: 15 }}>
            An email with the details about your registration has been sent to the email address provided.
            </Typography>
            <Typography align='center' style={{ fontSize: 12, marginTop: 5 }}>
            Please keep it for your records.
            </Typography>
  
            <Grid style={{ width: "100%", maxWidth: 500, height: 2, borderBottom: '1px solid white', opacity: .5, marginTop: 20, marginBottom: 10  }}/>
            
  
            <Typography align='center' style={{ fontSize: 12, marginTop: 15 }}>
            We're dedicated to giving you the best experience possible. 
            </Typography>
            <Typography align='center' style={{ fontSize: 12, marginTop: 5 }}>
            If you have any questions please don't hesitate to contact us (+(65) 6622 5520)
            </Typography>
            <Button variant="contained" style={{ marginTop: 20 }} href={`/contactus`}   disableElevation>
            Back
            </Button>
          </Grid>
        </Grid>
  
      )
    }

  return (
    <>
      <Helmet>
        <title> Contact Us | OneT | Leading DevSecOps Service Provider</title>
      </Helmet>

      <Grid style={{top: 0, width: '100%',
        display: "flex",justifyContent: "center", alignItems: "center",  flexDirection: "column"  }}>

{matches ? <Grid style={{ zIndex:-1, position: "fixed", top: 0,backgroundColor: '#1b0049', 
        width: "100%",
        display: "flex", justifyContent: "flex-end", flexDirection: "column"  }}>
            <video height={"100%"} className='videoTag' playsInline autoPlay loop muted>
                <source src={"/assets/videobg.mp4"} type='video/mp4' />
            </video>
          </Grid> : <Grid style={{ zIndex:-1, position: "fixed", top: 0,backgroundColor: '#1b0049', 
        
        height: "110vh",
        display: "flex", justifyContent: "flex-end", flexDirection: "column"  }}>
            <video height={"100%"} className='videoTag' playsInline autoPlay loop muted>
                <source src={"/assets/videobg.mp4"} type='video/mp4' />
            </video>
          </Grid>}
      

        <Grid style={{  maxWidth: 1200, zIndex:1, marginTop: 120, width: "100%", display: "flex", padding: 25,  paddingTop: 60, paddingBottom: 80,
            flexDirection: "column", justifyContent: "center", backgroundColor: "Transparent" }}>
            <Typography style={{ fontWeight: "bold", fontSize: 40, color: 'white', textTransform: "uppercase" }}>
            {title}
            </Typography>
            <Typography style={{marginTop: -10, fontWeight: "lighter", fontSize: 40, color: 'white', textTransform: "uppercase" }}>
            {subtitle}
            </Typography>
        </Grid>

        <Grid style={{ zIndex:1, backgroundColor: '#1b0049', width: "100%", display: "flex",justifyContent: "center", alignItems: "center",  
                  flexDirection: "column" }}>
                    <Grid style={{  padding: 25, maxWidth: 1200, marginTop: 10, width: "100%", display: "flex", alignItems: "center",
                      flexDirection: "column",  backgroundColor: "Transparent" }}>
                        <Typography style={{ textAlign: "center", fontWeight: "bold", fontSize: 36, color: 'white', textTransform: "uppercase" }}>
                        Connect With Us
                        </Typography>
        
                    </Grid>
        
                    <Grid container spacing={2} style={{ padding: 25, maxWidth: 1200 }}>
                      <Grid item lg={6} xs={12} style={{ cursor:'pointer' }} >

                        <Grid>
                          <Typography style={{ marginLeft: 5, maxWidth: 500,fontSize: 16, color: "#af9ad3" }}>
                          We're here to help and answer any questions you might have. We look forward to hearing from you!
                            </Typography>
                           
                        </Grid>

                        <Grid style={{ marginTop: 20 }}>
                          <Grid style={{ display:"flex", flexDirection: "row"}}>
                            <img src='assets/icons8-phone-30.png' alt='phone icon' height={17} />
                            <Typography style={{ marginTop: -3, marginLeft: 5, maxWidth: 500,fontWeight: "bold", fontSize: 16, color: 'white' }}>
                            Phone
                            </Typography>
                          </Grid>
                           
                          <Typography style={{maxWidth: 500, fontSize: 14, color: "#af9ad3" }}>
                          +(65) 6622 5520
                          </Typography>
                        </Grid>

                        <Grid style={{ marginTop: 20 }}>
                          <Grid style={{ display:"flex", flexDirection: "row"}}>
                            <img src='assets/icons8-email-48.png' alt='email icon' height={17} />
                            <Typography style={{ marginTop: -3, marginLeft: 5, maxWidth: 500,fontWeight: "bold", fontSize: 16, color: 'white' }}>
                            Email
                            </Typography>
                          </Grid>
                           
                          <Typography style={{maxWidth: 500, fontSize: 14, color: "#af9ad3" }}>
                          info@onet.sg
                          </Typography>
                        </Grid>

                        <Grid style={{ marginTop: 20 }}>
                          <Grid style={{ display:"flex", flexDirection: "row"}}>
                            <img src='assets/icons8-address-48.png' alt='address icon' height={17} />
                            <Typography style={{ marginTop: -3, marginLeft: 5, maxWidth: 500,fontWeight: "bold", fontSize: 16, color: 'white' }}>
                            Address
                            </Typography>
                          </Grid>
                          <Typography style={{maxWidth: 500, fontSize: 14, color: "#af9ad3" }}>
                          One Raffles Quay,
                          </Typography>
                          <Typography style={{maxWidth: 500, fontSize: 14, color: "#af9ad3" }}>
                          North Tower, Level 49,
                          </Typography>
                          <Typography style={{maxWidth: 500,fontSize: 14, color: "#af9ad3" }}>
                          Singapore 048583
                          </Typography>
                        </Grid>
                        
                      </Grid>
                      <Grid item lg={6} xs={12}  style={{ cursor:'pointer' }} >
                      <Box component="form" noValidate onSubmit={handleSubmit}>
                        <Grid container spacing={2}>
                          <Grid item xs={12} sm={6}>
                            <TextField
                              autoComplete="given-name"
                              name="firstName"
                              required
                              error={firstNameError}
                              fullWidth
                              id="firstName"
                              label="First Name"
                              autoFocus
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <TextField
                              required
                              fullWidth
                              error={lastNameError}
                              id="lastName"
                              label="Last Name"
                              name="lastName"
                              autoComplete="family-name"
                            />
                          </Grid>
                          
                          <Grid item xs={12} sm={12}>
                            <TextField
                              fullWidth
                              id="company"
                              label="Company"
                              name="company"
                              autoComplete="company-name"
                            />
                            <Typography style={{ fontSize: 10, marginTop: 5, paddingLeft: 10 }}>e.g. One T Pte Ltd</Typography>
                          </Grid>
                          <Grid item xs={12}>
                            <TextField
                              required
                              fullWidth
                              id="email"
                              error={emailError}
                              label="Email Address"
                              name="email"
                              autoComplete="email"
                            />
                            <Typography style={{ fontSize: 10, marginTop: 5, paddingLeft: 10 }}>e.g. abc@gmail.com </Typography>
                          </Grid>
                          <Grid item xs={12} >
                            <PhoneInput
                              fullWidth
                              country={'sg'}
                              inputStyle={{ width: "100%", backgroundColor: "transparent", color: "white", opacity: .5}}
                              searchStyle={{ width: "100%", backgroundColor: "transparent"}}
                              containerStyle={{ backgroundColor: "transparent" }}
                              specialLabel=''
                              style={{ margin: 0, marginTop: 15, width: "100%", backgroundColor: "transparent" }}
                              value={mobileNum}
                              onChange={handleChangeMobileNum}
                            />
                            <Typography style={{ fontSize: 10, marginTop: 5, paddingLeft: 10 }}>e.g. +65 2345 6789   </Typography>
                            {mobileNumError ? <Typography style={{  fontSize: 11, color: 'red' }}>
                        Mobile Number Invalid
                        </Typography> : null }
                          </Grid>

                          <Grid item xs={12} sm={12}>
                            <TextField
                              fullWidth
                              rows={4}
                              multiline
                              error={messageError}
                              id="message"
                              label="Message"
                              name="message"
                              autoComplete="message"
                            />
                          </Grid>

                          </Grid>
                          <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            sx={{ mt: 3, mb: 2, backgroundColor: "#dd4970", '&:hover': { backgroundColor: "#b32d50" } }}
                          >
                            Submit
                          </Button>
                        </Box>
                      </Grid>
                      
                    </Grid>
          </Grid>
        
      </Grid>
    </>
  );
}
